export interface BibleBook {
  id: string
  name: string
  chapters: number
  testament: 'OT' | 'NT'
}

export const BIBLE_BOOKS: BibleBook[] = [
  // Old Testament
  { id: 'GEN', name: 'Genesis', chapters: 50, testament: 'OT' },
  { id: 'EXO', name: 'Exodus', chapters: 40, testament: 'OT' },
  { id: 'LEV', name: 'Leviticus', chapters: 27, testament: 'OT' },
  { id: 'NUM', name: 'Numbers', chapters: 36, testament: 'OT' },
  { id: 'DEU', name: 'Deuteronomy', chapters: 34, testament: 'OT' },
  { id: 'JOS', name: 'Joshua', chapters: 24, testament: 'OT' },
  { id: 'JDG', name: 'Judges', chapters: 21, testament: 'OT' },
  { id: 'RUT', name: 'Ruth', chapters: 4, testament: 'OT' },
  { id: '1SA', name: '1 Samuel', chapters: 31, testament: 'OT' },
  { id: '2SA', name: '2 Samuel', chapters: 24, testament: 'OT' },
  { id: '1KI', name: '1 Kings', chapters: 22, testament: 'OT' },
  { id: '2KI', name: '2 Kings', chapters: 25, testament: 'OT' },
  { id: '1CH', name: '1 Chronicles', chapters: 29, testament: 'OT' },
  { id: '2CH', name: '2 Chronicles', chapters: 36, testament: 'OT' },
  { id: 'EZR', name: 'Ezra', chapters: 10, testament: 'OT' },
  { id: 'NEH', name: 'Nehemiah', chapters: 13, testament: 'OT' },
  { id: 'EST', name: 'Esther', chapters: 10, testament: 'OT' },
  { id: 'JOB', name: 'Job', chapters: 42, testament: 'OT' },
  { id: 'PSA', name: 'Psalms', chapters: 150, testament: 'OT' },
  { id: 'PRO', name: 'Proverbs', chapters: 31, testament: 'OT' },
  { id: 'ECC', name: 'Ecclesiastes', chapters: 12, testament: 'OT' },
  { id: 'SNG', name: 'Song of Solomon', chapters: 8, testament: 'OT' },
  { id: 'ISA', name: 'Isaiah', chapters: 66, testament: 'OT' },
  { id: 'JER', name: 'Jeremiah', chapters: 52, testament: 'OT' },
  { id: 'LAM', name: 'Lamentations', chapters: 5, testament: 'OT' },
  { id: 'EZK', name: 'Ezekiel', chapters: 48, testament: 'OT' },
  { id: 'DAN', name: 'Daniel', chapters: 12, testament: 'OT' },
  { id: 'HOS', name: 'Hosea', chapters: 14, testament: 'OT' },
  { id: 'JOL', name: 'Joel', chapters: 3, testament: 'OT' },
  { id: 'AMO', name: 'Amos', chapters: 9, testament: 'OT' },
  { id: 'OBA', name: 'Obadiah', chapters: 1, testament: 'OT' },
  { id: 'JON', name: 'Jonah', chapters: 4, testament: 'OT' },
  { id: 'MIC', name: 'Micah', chapters: 7, testament: 'OT' },
  { id: 'NAM', name: 'Nahum', chapters: 3, testament: 'OT' },
  { id: 'HAB', name: 'Habakkuk', chapters: 3, testament: 'OT' },
  { id: 'ZEP', name: 'Zephaniah', chapters: 3, testament: 'OT' },
  { id: 'HAG', name: 'Haggai', chapters: 2, testament: 'OT' },
  { id: 'ZEC', name: 'Zechariah', chapters: 14, testament: 'OT' },
  { id: 'MAL', name: 'Malachi', chapters: 4, testament: 'OT' },
  // New Testament
  { id: 'MAT', name: 'Matthew', chapters: 28, testament: 'NT' },
  { id: 'MRK', name: 'Mark', chapters: 16, testament: 'NT' },
  { id: 'LUK', name: 'Luke', chapters: 24, testament: 'NT' },
  { id: 'JHN', name: 'John', chapters: 21, testament: 'NT' },
  { id: 'ACT', name: 'Acts', chapters: 28, testament: 'NT' },
  { id: 'ROM', name: 'Romans', chapters: 16, testament: 'NT' },
  { id: '1CO', name: '1 Corinthians', chapters: 16, testament: 'NT' },
  { id: '2CO', name: '2 Corinthians', chapters: 13, testament: 'NT' },
  { id: 'GAL', name: 'Galatians', chapters: 6, testament: 'NT' },
  { id: 'EPH', name: 'Ephesians', chapters: 6, testament: 'NT' },
  { id: 'PHP', name: 'Philippians', chapters: 4, testament: 'NT' },
  { id: 'COL', name: 'Colossians', chapters: 4, testament: 'NT' },
  { id: '1TH', name: '1 Thessalonians', chapters: 5, testament: 'NT' },
  { id: '2TH', name: '2 Thessalonians', chapters: 3, testament: 'NT' },
  { id: '1TI', name: '1 Timothy', chapters: 6, testament: 'NT' },
  { id: '2TI', name: '2 Timothy', chapters: 4, testament: 'NT' },
  { id: 'TIT', name: 'Titus', chapters: 3, testament: 'NT' },
  { id: 'PHM', name: 'Philemon', chapters: 1, testament: 'NT' },
  { id: 'HEB', name: 'Hebrews', chapters: 13, testament: 'NT' },
  { id: 'JAS', name: 'James', chapters: 5, testament: 'NT' },
  { id: '1PE', name: '1 Peter', chapters: 5, testament: 'NT' },
  { id: '2PE', name: '2 Peter', chapters: 3, testament: 'NT' },
  { id: '1JN', name: '1 John', chapters: 5, testament: 'NT' },
  { id: '2JN', name: '2 John', chapters: 1, testament: 'NT' },
  { id: '3JN', name: '3 John', chapters: 1, testament: 'NT' },
  { id: 'JUD', name: 'Jude', chapters: 1, testament: 'NT' },
  { id: 'REV', name: 'Revelation', chapters: 22, testament: 'NT' },
]

export const OT_BOOKS = BIBLE_BOOKS.filter((b) => b.testament === 'OT')
export const NT_BOOKS = BIBLE_BOOKS.filter((b) => b.testament === 'NT')

export function getBookById(id: string): BibleBook | undefined {
  return BIBLE_BOOKS.find((b) => b.id === id)
}

export function getNextChapter(bookId: string, chapter: number): { bookId: string; chapter: number } | null {
  const book = getBookById(bookId)
  if (!book) return null
  if (chapter < book.chapters) return { bookId, chapter: chapter + 1 }
  const idx = BIBLE_BOOKS.findIndex((b) => b.id === bookId)
  if (idx < BIBLE_BOOKS.length - 1) return { bookId: BIBLE_BOOKS[idx + 1].id, chapter: 1 }
  return null
}

export function getPrevChapter(bookId: string, chapter: number): { bookId: string; chapter: number } | null {
  if (chapter > 1) return { bookId, chapter: chapter - 1 }
  const idx = BIBLE_BOOKS.findIndex((b) => b.id === bookId)
  if (idx > 0) {
    const prevBook = BIBLE_BOOKS[idx - 1]
    return { bookId: prevBook.id, chapter: prevBook.chapters }
  }
  return null
}

// Aliases map: lowercase variant → canonical BIBLE_BOOKS name
// Synced from backend utils/bible_refs.py BOOK_NAMES
const BOOK_ALIASES: Record<string, string> = {
  // OT abbreviations
  'gen': 'Genesis', 'ge': 'Genesis',
  'exod': 'Exodus', 'ex': 'Exodus',
  'lev': 'Leviticus', 'le': 'Leviticus',
  'num': 'Numbers', 'nu': 'Numbers',
  'deut': 'Deuteronomy', 'dt': 'Deuteronomy',
  'josh': 'Joshua', 'jos': 'Joshua',
  'judg': 'Judges', 'jdg': 'Judges',
  'ru': 'Ruth',
  '1 sam': '1 Samuel', '1sam': '1 Samuel',
  '2 sam': '2 Samuel', '2sam': '2 Samuel',
  '1 kgs': '1 Kings', '1kgs': '1 Kings',
  '2 kgs': '2 Kings', '2kgs': '2 Kings',
  '1 chr': '1 Chronicles', '1chr': '1 Chronicles', '1 chron': '1 Chronicles',
  '2 chr': '2 Chronicles', '2chr': '2 Chronicles', '2 chron': '2 Chronicles',
  'ezr': 'Ezra',
  'neh': 'Nehemiah', 'ne': 'Nehemiah',
  'est': 'Esther', 'esth': 'Esther',
  'jb': 'Job',
  'psalm': 'Psalms', 'ps': 'Psalms', 'psa': 'Psalms',
  'prov': 'Proverbs', 'pr': 'Proverbs',
  'eccl': 'Ecclesiastes', 'ecc': 'Ecclesiastes',
  'song of songs': 'Song of Solomon', 'song': 'Song of Solomon', 'sos': 'Song of Solomon',
  'isa': 'Isaiah',
  'jer': 'Jeremiah', 'je': 'Jeremiah',
  'lam': 'Lamentations', 'la': 'Lamentations',
  'ezek': 'Ezekiel', 'eze': 'Ezekiel',
  'dan': 'Daniel', 'da': 'Daniel',
  'hos': 'Hosea', 'ho': 'Hosea',
  'joe': 'Joel', 'jl': 'Joel',
  'am': 'Amos',
  'obad': 'Obadiah', 'ob': 'Obadiah',
  'jon': 'Jonah', 'jnh': 'Jonah',
  'mic': 'Micah', 'mi': 'Micah',
  'nah': 'Nahum', 'na': 'Nahum',
  'hab': 'Habakkuk',
  'zeph': 'Zephaniah', 'zep': 'Zephaniah',
  'hag': 'Haggai', 'hg': 'Haggai',
  'zech': 'Zechariah', 'zec': 'Zechariah',
  'mal': 'Malachi',
  // NT abbreviations
  'matt': 'Matthew', 'mt': 'Matthew',
  'mk': 'Mark', 'mr': 'Mark',
  'lk': 'Luke', 'lu': 'Luke',
  'jn': 'John', 'joh': 'John',
  'ac': 'Acts',
  'rom': 'Romans', 'ro': 'Romans',
  '1 cor': '1 Corinthians', '1cor': '1 Corinthians',
  '2 cor': '2 Corinthians', '2cor': '2 Corinthians',
  'gal': 'Galatians', 'ga': 'Galatians',
  'eph': 'Ephesians',
  'phil': 'Philippians', 'php': 'Philippians',
  'col': 'Colossians',
  '1 thess': '1 Thessalonians', '1thess': '1 Thessalonians', '1 th': '1 Thessalonians',
  '2 thess': '2 Thessalonians', '2thess': '2 Thessalonians', '2 th': '2 Thessalonians',
  '1 tim': '1 Timothy', '1tim': '1 Timothy',
  '2 tim': '2 Timothy', '2tim': '2 Timothy',
  'tit': 'Titus',
  'phlm': 'Philemon', 'phm': 'Philemon',
  'heb': 'Hebrews',
  'jas': 'James', 'jm': 'James',
  '1 pet': '1 Peter', '1pet': '1 Peter', '1 pe': '1 Peter',
  '2 pet': '2 Peter', '2pet': '2 Peter', '2 pe': '2 Peter',
  '1 jn': '1 John', '1jn': '1 John',
  '2 jn': '2 John', '2jn': '2 John',
  '3 jn': '3 John', '3jn': '3 John',
  'jd': 'Jude',
  'rev': 'Revelation', 're': 'Revelation', 'revelations': 'Revelation',
}

// Pre-built lookup map for O(1) book name resolution
const BOOK_BY_NAME = new Map(BIBLE_BOOKS.map((b) => [b.name.toLowerCase(), b]))

export function parseReference(ref: string): { bookId: string; chapter: number; verse?: number } | null {
  const match = ref.match(/^(\d?\s*[A-Za-z .]+?)\s+(\d+)(?::(\d+))?/)
  if (!match) return null
  const rawName = match[1].trim().replace(/\.$/, '')
  const chapter = parseInt(match[2], 10)
  const verse = match[3] ? parseInt(match[3], 10) : undefined
  const lower = rawName.toLowerCase()
  const canonical = BOOK_ALIASES[lower]
  const book = canonical ? BOOK_BY_NAME.get(canonical.toLowerCase()) : BOOK_BY_NAME.get(lower)
  if (!book || chapter < 1 || chapter > book.chapters) return null
  return { bookId: book.id, chapter, verse }
}
